import clamp from '../../../math/clamp';
import elt from '../../../html/elt';
import injectCSS from '../../../html/inject-css';
import logging from '../../../logging';

const log = logging('components');

export class IntegerInput extends HTMLElement {

    private _value: number = 0;
    private _disabled: boolean = false;
    private inc: HTMLButtonElement;
    private dec: HTMLButtonElement;
    private input: HTMLInputElement;
    private min: number;
    private max: number;

    constructor() {
        super();
        injectCSS(STYLESHEET);
        this.inc = elt('button', {class: 'inc btn btn-secondary'},
                      elt('i', {class: 'bi bi-chevron-up'}));
        this.dec = elt('button', {class: 'dec btn btn-secondary'},
                       elt('i', {class: 'bi bi-chevron-down'}));
        this.input = elt('input', {type: 'text', class: 'form-control'});
    }

    connectedCallback() {
        this.classList.add('input-group');
        this.append(this.dec, this.input, this.inc);

        this.min = Number(this.getAttribute("min") || -Infinity);
        this.max = Number(this.getAttribute("max") || Infinity);

        const step = 1;
        this.input.addEventListener('change', () => this.update());
        this.inc.addEventListener('click', () => this.value += step);
        this.dec.addEventListener('click', () => this.value -= step);

        this.display();
    }

    get value() {
        return Number(this._value);
    }

    set value(newvalue) {
        if(this._value != newvalue) {
            log.debug('IntegerInput set value');
            this._value = clamp(Number(newvalue), this.min, this.max);
            this.display();
            this.dispatchEvent(new CustomEvent('change'));
        }
    }

    get disabled() {
        return this._disabled;
    }

    set disabled(value) {
        this.input.disabled = value;
        this.inc.disabled = value;
        this.dec.disabled = value;
    }

    update() {
        let newvalue = Math.round(Number(this.input.value));
        this.value = newvalue;
    }

    display() {
        this.input.value = String(Math.round(this.value));
        this.dispatchEvent(new CustomEvent('viewport-update', { bubbles: true }));
    }

}
export default IntegerInput;
window.customElements.define('integer-input', IntegerInput);
log.debug('Defined custom element <integer-input>');

const STYLESHEET = `
integer-input {
    & button {
        appearance: none;
        border: none;
        background-color: rgba(0, 0, 0, 0.1);
        font-weight: bold;
        font-size: 16px;

        cursor: pointer;
    }

    & input {
        width: 7ch;
    }
}
`;
